import React from "react";
import Body from "../components/HomeImage";
import Footer from "../components/Footer";
import Text from "../components/Text";
import { TEXT } from "../utility/constants";
import TextBox from "../components/TextBox";
import staffing from "../assets/images/staffing.png";
import storage from "../assets/images/storage.png";
import infra from "../assets/images/infra.png";
import maintenance from "../assets/images/maintenance.png";
import { motion } from "framer-motion";
import "../csscontainer/Home.css";
function Home() {
  console.log(TEXT);

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="home-wrapper">
        <Body />
        <Text
          color="#120541FF"
          size="24px"
          weight="bold"
          align="start"
          style={{ marginTop: "80px" }}
        >
          {TEXT.HomeTitle}
        </Text>

        <Text
          color="#141313FF"
          size="20px"
          weight="bold"
          align="start"
          style={{ marginBottom: "15px", marginTop: "20px" }}
        >
          {TEXT.HomeSubtitle}
        </Text>
        <Text
          color="#555"
          width="60%"
          size="18px"
          align="start"
          style={{ width: "60%", lineHeight: "1.6", marginBottom: "40px" }}
        >
          {TEXT.HOME_DESCRIPTION}
        </Text>

        <Text
          color="#120541FF"
          width="60%"
          size="18px"
          align="start"
          style={{ width: "60%", lineHeight: "1.6", marginBottom: "40px" }}
        >
          {TEXT.HOME2}
        </Text>

        <Text
          color="#555"
          width="60%"
          size="18px"
          align="start"
          style={{ width: "60%", lineHeight: "1.6", marginBottom: "40px" }}
        >
          {TEXT.HOME3}
        </Text>

        <div className="row-containers">
          <TextBox
            imageSrc={staffing}
            title={TEXT.Home8}
            description={TEXT.Home81}
            bulletPoints={[TEXT.Home82, TEXT.Home83]}
            showBorder={true}
          />
          <TextBox
            imageSrc={storage}
            title={TEXT.Home6}
            description={TEXT.Home61}
            bulletPoints={[TEXT.Home62, TEXT.Home63, Text.Home64]}
            showBorder={true}
          />
        </div>

        <div className="row-containers">
          <TextBox
            imageSrc={maintenance}
            title={TEXT.Home7}
            description={TEXT.Home71}
            bulletPoints={[TEXT.Home72, TEXT.Home73, Text.Home74]}
            showBorder={true}
          />
          <TextBox
            imageSrc={infra}
            title={TEXT.Home5}
            description={TEXT.Home50}
            bulletPoints={[TEXT.Home51, TEXT.Home52, Text.Home53]}
            showBorder={true}
          />
        </div>
        <Text
          color="120541FF"
          width="60%"
          size="18px"
          align="start"
          style={{
            width: "60%",
            lineHeight: "1.6",
            marginBottom: "00px",
            marginTop: "80px",
          }}
        >
          {TEXT.Home10}
        </Text>
        <Footer />
      </div>
    </motion.div>
  );
}

export default Home;
